import { Redirect, Route, useLocation } from 'react-router-dom';
import { getIntegrationKey } from '../routing/getIntegrationKey';
import { isIntegrationValid } from 'signup-ui-lego-core/utils/isIntegrationValid';
import { jsx as _jsx } from "react/jsx-runtime";
const IntegrationsRoute = props => {
  const {
    hash,
    search
  } = useLocation();
  const searchParams = new URLSearchParams(search);
  const integrationKey = getIntegrationKey();
  if (!isIntegrationValid(integrationKey)) {
    searchParams.delete('integration');
    return /*#__PURE__*/_jsx(Redirect, {
      to: {
        pathname: `/`,
        search: searchParams.toString(),
        hash
      }
    });
  }
  return /*#__PURE__*/_jsx(Route, Object.assign({}, props));
};
export default IntegrationsRoute;